import { render, staticRenderFns } from "./RecruitmentContent.vue?vue&type=template&id=4024329a&scoped=true&"
import script from "./RecruitmentContent.vue?vue&type=script&lang=js&"
export * from "./RecruitmentContent.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentContent.vue?vue&type=style&index=0&id=4024329a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024329a",
  null
  
)

export default component.exports